module.exports = __webpack_public_path__ + "static/media/android_tips_02.8bdaa0b8.png";